// Date helpers — all dates flow through here so TZ behaviour is
// consistent across views. ISO strings (YYYY-MM-DD) are the wire
// format; Date objects only exist inside computation helpers.

export function isoToday(): string {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return toIsoDate(d);
}

export function toIsoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function addDays(iso: string | Date, n: number): string {
  const d = typeof iso === "string" ? new Date(iso) : new Date(iso.getTime());
  d.setDate(d.getDate() + n);
  return toIsoDate(d);
}

export function daysBetween(a: string | Date, b: string | Date): number {
  const A = typeof a === "string" ? new Date(a) : a;
  const B = typeof b === "string" ? new Date(b) : b;
  return Math.ceil((B.getTime() - A.getTime()) / 86_400_000);
}

// Locale-aware short label, e.g. "12 Apr". Falls back to em-dash on
// missing/invalid input so render code stays branch-free.
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short" });
}

export function startOfLocalDay(d: Date = new Date()): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

export function isOverdue(due: string | null, status: string): boolean {
  if (!due) return false;
  if (status === "Complete" || status === "Cancelled") return false;
  return new Date(due).getTime() < startOfLocalDay().getTime();
}
